export default "__VITE_ASSET__TN36cv8I__"